<template>
<div class="devDetailDW basicInfoContainerGas">
  <div class="detailsDrawerBody" :style="styleObject">
    <div class="basic detailsItem">
      <!-- <h4>基本信息</h4> -->
      <div class="details">
        <el-scrollbar wrap-class="scrollbar-wrapper" ref="myScrollbar">
          <ul>
            <li>
              <div class="label">设备名称</div>
              <div class="value deviceName" :style="styleObj">
                <el-input :title="datailsData.name" type="text" v-model="datailsData.name" :disabled="!commitFlag" :placeholder="datailsData.name"></el-input>
              </div>
            </li>
            <li>
              <div class="label">设备ID</div>
              <div class="value">{{ datailsData.termCode }}</div>
            </li>
            <li>
              <div class="label">安装区域</div>
              <!-- <div v-if="datailsData.terminalFlag" class="value">{{ regionName }}</div> -->
              <!-- <div v-else> -->
                <div v-if="!commitFlag" class="value">{{ regionName }}</div>
                <div v-else class="value treeselect-box" style="padding:0;" :style="!commitFlag?'':styleObj">
                  <treeselect
                    :multiple="false"
                    :options="regionOptions"
                    :load-options="loadOptions"
                    @select="treeEven"
                    :disabled="!commitFlag"
                    v-model="regionId"
                    :normalizer="normalizer"
                    placeholder="请选择区域" />
                </div>
              <!-- </div> -->
            </li>
            <li>
              <div class="label">IMEI</div>
              <div class="value">{{ datailsData.imei }}</div>
            </li>
            <li>
              <div class="label">设备类型</div>
              <div class="value">{{ datailsData.typeName }}</div>
            </li>
            <!-- <li>
              <div class="label">是否注册</div>
              <div class="value">{{ datailsData.isRegist }}</div>
            </li>
            <li v-if="datailsData.isRegist == '已注册'">
              <div class="label">设备注册至</div>
              <div class="value">{{ datailsData.registType }}</div>
            </li> -->
            <!-- <li>
              <div class="label">是否安装</div>
              <div class="value">{{ datailsData.isInstall }}</div>
            </li> -->
            <li>
              <div class="label">报警状态</div>
              <div class="value">{{ datailsData.isAlarm }}</div>
            </li>
            <li>
              <div class="label">故障状态</div>
              <div class="value">{{ datailsData.isFault }}</div>
            </li>
            <li>
              <div class="label">是否启用</div>
              <div class="value">{{ datailsData.isEnabled }}</div>
            </li>
            <li>
              <div class="label">是否在线</div>
              <div class="value">{{ datailsData.isOnline }}</div>
            </li>
            <!-- <li>
              <div class="label">通知人员类型</div>
              <div class="value">
                {{
                    datailsData.noticeUserType == 1 ? '通知负责人' : datailsData.noticeUserType == 2 ? '通知安装人' :datailsData.noticeUserType == 3 ? '通知安装人和负责人':''
                  }}
              </div>
            </li> -->

            <li>
              <div class="label">通信类型</div>
              <div class="value">{{ datailsData.protocol == 0 ? 'MQTT':datailsData.protocol == 1 ? 'NB' : datailsData.protocol == 2 ? 'HTTP' : datailsData.protocol == 3 ? 'TCP' :''}}</div>
            </li>
            <li v-if=" datailsData.isInstall == '已安装' ">
              <div class="label">设备定位</div>
              <div class="value unitType" :style="styleObj">
                <el-input ref="addrInput" :title="selectLocation.address" v-model="selectLocation.address" :disabled="!disabled" maxlength="50" :placeholder="selectLocation.address"></el-input><i class="imgPosition" v-show="commitFlag" @click="showMap">&nbsp;&nbsp;&nbsp;<img src="../../../assets/img/position.png" alt=""></i>
              </div>
            </li>
            <li v-if=" datailsData.isInstall == '已安装' ">
              <div class="label">安装经纬度</div>
              <div class="value">{{ datailsData.installGps }}</div>
            </li>
            <li v-if=" datailsData.isInstall == '已安装' ">
              <div class="label">安装位置</div>
              <div class="value unitType" :style="styleObj">
                <!-- {{ datailsData.installLocation }} -->
                <el-input ref="addrInput" :title="datailsData.installLocation" v-model="datailsData.installLocation" :disabled="!commitFlag" maxlength="50" :placeholder="datailsData.installLocation"></el-input>
              </div>
            </li>
            <li v-if="datailsData.isInstall  == '已安装'">
              <div class="label">安装时间</div>
              <div class="value">{{ datailsData.installTime }}</div>
            </li>
            <!-- <li>
              <div class="label">使用者</div>
              <div class="value">{{ datailsData.user }}</div>
            </li>
            <li>
              <div class="label">使用者联系方式</div>
              <div class="value">{{ datailsData.userTel }}</div>
            </li> -->
            <li v-if=" datailsData.isInstall == '已安装' ">
              <div class="label">安装人员</div>
              <div class="value">{{ datailsData.installUser }}</div>
            </li>
            <li v-if=" datailsData.isInstall == '已安装' ">
              <div class="label">安装人员联系方式</div>
              <div class="value">{{ datailsData.installUserTel }}</div>
            </li>
            <!-- <li>
              <div class="label">入库时间</div>
              <div class="value">{{ datailsData.createTime }}</div>
            </li>
            <li v-if="datailsData.isRegist == '已注册'">
              <div class="label">注册时间</div>
              <div class="value">{{ datailsData.registTime }}</div>
            </li> -->
            <li>
              <div class="label">硬件版本</div>
              <div class="value">{{ datailsData.hardwareVersion }}</div>
            </li>
            <li>
              <div class="label">软件版本</div>
              <div class="value">{{ datailsData.softwareVersion }}</div>
            </li>
            <!-- <li>
              <div class="label">厂商编号</div>
              <div class="value">{{ datailsData.manufacturer }}</div>
            </li>
            <li>
              <div class="label">开关数量</div>
              <div class="value">{{ datailsData.switchAmount }}</div>
            </li>
            <li>
              <div class="label">串口数量</div>
              <div class="value">{{ datailsData.serialPortAmount }}</div>
            </li>
            <li>
              <div class="label">信号强度</div>
              <div class="value">{{ datailsData.signalStrength }}</div>
            </li>
            <li>
              <div class="label">通讯类型</div>
              <div class="value">{{ datailsData.communicationType }}</div>
            </li>
            <li>
              <div class="label">温度</div>
              <div class="value">{{ datailsData.temp }}&nbsp;{{datailsData.temp?'℃':''}}</div>
            </li>
            <li>
              <div class="label">CH4</div>
              <div class="value">{{ datailsData.ch4 }}&nbsp;{{ datailsData.ch4Unit }}</div>
            </li>
            <li>
              <div class="label">C3H8</div>
              <div class="value">{{ datailsData.c3H8 }}&nbsp;{{ datailsData.c3H8Unit }}</div>
            </li>
            <li>
              <div class="label">CO</div>
              <div class="value">{{ datailsData.co }}&nbsp;{{ datailsData.counit }}</div>
            </li>
            <li>
              <div class="label">h2S</div>
              <div class="value">{{ datailsData.h2S }}&nbsp;{{ datailsData.h2SUnit }}</div>
            </li>
            <li>
              <div class="label">o2</div>
              <div class="value">{{ datailsData.o2 }}&nbsp;{{ datailsData.o2Unit }}</div>
            </li> -->
            <li>
              <div class="label">负责人、联系方式</div>
              <div class="value" v-if="!regionInfos.length"></div>
              <div v-else>
                <div class="value"  v-for="(item,index) in regionInfos" :key="index" style="marginBottom:10px;">
                  <span>{{item.nickName}}</span><span>（{{item.tel}}）</span>
                </div>
              </div>
            </li>
          </ul>
          <div class="submitBtns">
            <button class="delSome" v-if="!commitFlag&&!datailsData.terminalFlag" @click="editBasicinfo()">编辑</button>
            <button class="delSome" v-if="commitFlag" @click="submitBasicinfo()">提交</button>
            <button class="delSome uninstall" v-if="commitFlag" @click="cancelBasicinfo()">取消</button>
            <button class="delSome uninstalls" v-if="datailsData.isInstallByMyself" @click="uninstallDevice()">拆除</button>
            <el-button type="primary" plain v-if="isShow" @click="unOutDevice()" :loading="isUnOut">解除</el-button>
            <!-- <button class="delSome uninstall">解除</button> -->
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
  <div class="unitMap" :style="{left : mapShow ? '0' : '100%'}">
    <div class="closeBtn" @click="mapShow = false"><i class="el-icon-circle-close" /></div>
    <div class="mapBox" v-loading="mapLoading">
      <div id="map" />
      <div class="input-box">
        <label>请输入关键字：</label>
        <input id="tipinput" type="text">
      </div>
      <!-- <div class="mapSearch">
        <el-input ref="searchInput" v-model="mapSearch" placeholder="搜索地址"></el-input>
      </div>
      <baidu-map class="map" :center="center" :zoom="zoom" @ready="mapReady" @click="mapClick">
        <bm-view :style="{width:'100%',height: '100%'}"></bm-view>
        <bm-local-search :keyword="mapSearch" :auto-viewport="true" style="display:none;"></bm-local-search>
      </baidu-map> -->
      <div class="mapConfirm" v-if="!mapLoading">
        <span>{{selectLocation.address}}</span><i @click.stop="saveLocation">保存位置</i>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { LOAD_CHILDREN_OPTIONS, Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
  BaiduMap,
  BmNavigation,
  BmView,
  BmGeolocation,
  BmCityList
} from 'vue-baidu-map'
export default {
  components: {
    BaiduMap,
    BmNavigation,
    BmView,
    BmGeolocation,
    BmCityList,
    Treeselect
  },
  props: {
    deviceId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    deviceImei: {
      type: [Number, String],
      default: () => {
        return null;
      }
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'gas'
    }
  },
  data() {
    return {
      regionOptions:[{
        id: 0,
        label: '区域机构',
        value: 0,
        isDefaultExpanded: true,
        children: null
      }],
      regionId: null,
      mapShow: false,
      mapSearch: '',
      center: {
        lng: '116.404',
        lat: '39.915'
      },
      location: {
        lng: '116.404',
        lat: '39.915'
      },
      keyword: '',
      zoom: 14,
      baiduMap: null,
      map: null,
      geocoder: null,
      mapLoading: false,
      locationSelected: false,
      selectLocation: {},
      // selectAddress:{},
      styleObject: {
        height: ''
      },
      datailsData: {},
      disabled: false,
      mapWidth: 0,
      mapHeight: 0,
      commitFlag: false,
      styleObj: {},
      flag: false,
      regionInfos:[],
      regionName:'',
      isShow: false,
      isUnOut: false,
    };
  },
  watch: {
    deviceId(newV) {
      console.log(newV);
    },
    isMobile(newV) {
      console.log(newV);
    }
  },
  created() {
    // this.showRegionOptions()
    this.mapWidth = document.body.clientWidth * 0.8
    this.mapHeight = document.body.clientHeight * 0.8
    // console.log(this.deviceId)
    this.makeheight()
    this.detailDatas()
  },
  mounted() {
    let isMaxTenant = this.storage.getSession("isMaxTenant")
    // console.log(isMaxTenant == 0)
    // console.log(this.isMobile)
    if (isMaxTenant == 0 && this.isMobile) {
      this.isShow = true
    }
  },
  methods: {
    loadOptions ({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        let id = parentNode.id
        this.getTreeNode(id).then(res => {
          if (res.code == 200) {
            let children = res.data && res.data.map(item => {
              if (!item.isLeaf) item.children = null
              return item
            })
            parentNode.children = children
          }
          callback()
        })
      }
    },
    getTreeNode (pid = 0) {
      return new Promise((resolve, reject) => {
        this.request.get(`/front/device/region/findTreeNofenjiById?id=${pid}`).then(res => {
          // 看一级区域机构里有没有已填写的安装区域，没有则先
          // let data = (res.code == 200 && res.data) ? res.data : []
          // let isHaveValue = data.findIndex(({ id }) => id == this.regionId)
          // if (isHaveValue == -1) this.regionId = null
          resolve(res)
        }).catch(e => reject(e))
      })
    },
    showRegionOptions() {
      let params ={
        id : 0
      }
      this.request
        .get("/front/device/region/findTreeNoTerminalById",params)
        .then(rs => {
          if (200 === rs.code) {
            let RegionArr = rs.data;
            this.regionOptions = RegionArr && RegionArr.length ? RegionArr : [];
          } else {
            this.msg.error(rs.msg);
          }
        })
        .catch(e => this.msg.error(e));
    },
    treeEven(data){
      if (data.id === 0) {
        this.regionId = null
        this.$message({ type: 'warning', message: '请选择有效的安装区域！' })
      }
    },
    //重置==========================
    normalizer(node){
      // console.log(node)
      //去掉children=null的属性
      // if(node.children==null||node.children=='null'){
      //   delete node.children;
      // }
      return {
        id: node.value,
        label: node.label || this.regionName,
        // children: node.children&&node.children.length?node.children:'',
        // isDisabled: node.id==0 ? true : false || node.terminalFlag ==1 ? true:false
      };
    },
    // 点击弹框-选择位置
    showMap() {
      this.mapShow = true
      this.initMap()
    },
    // 初始化地图
    initMap() {
      const self = this
      self.mapLoading = true
      AMapUI.loadUI(['misc/PositionPicker'], function(PositionPicker) {
        var map = new AMap.Map('map', {
          zoom: 12,
          scrollWheel: false,
          resizeEnable: true
        })

        self.mapLoading = false

        var auto = new AMap.Autocomplete({ input: 'tipinput' })
        var placeSearch = new AMap.PlaceSearch({ map })
        AMap.event.addListener(auto, 'select', (e) => {
          // console.log(e)
          placeSearch.setCity(e.poi.adcode)
          placeSearch.search(e.poi.name)
        })

        // 缩放条-异步加载插件
        AMap.plugin('AMap.ToolBar', function() {
          var toolbar = new AMap.ToolBar({
            liteStyle: true,
            position: 'RT'
          })
          map.addControl(toolbar)
        })

        if (self.selectLocation.position) {
          let { lng, lat } = self.selectLocation.position

          map.setCenter([lng, lat])
        }

        var positionPicker = new PositionPicker({
          mode: 'dragMap',
          // mode: 'dragMarker',
          map
        })

        positionPicker.on('success', function(positionResult) {

          // self.lnglat = `${position.lng},${position.lat}`
          self.selectLocation = positionResult
        })
        positionPicker.on('fail', function(positionResult) {
          // self.lnglat = ''
          self.selectLocation = {}
          console.error(positionResult)
        })

        positionPicker.start()
      })
    },
    // mapShowClick() {
    //   this.mapShow = true
    //   if (!this.locationSelected) {
    //     this.mapLoading = true
    //   }
    //   //地图定位到选中项位置
    //   if (!this.datailsData.installGps) {
    //     return
    //   }
    //   let map = this.map
    //   let BMap = this.baiduMap
    //   let installGps = this.datailsData.installGps.split(',')
    //   map.clearOverlays()
    //   this.center.lng = installGps[0] ? installGps[0] : '116.404'
    //   this.center.lat = installGps[1] ? installGps[1] : '39.915'
    //   let point = new BMap.Point(this.center.lng, this.center.lat);
    //   var marker = new BMap.Marker(point); // 创建标注
    //   map.addOverlay(marker); // 将标注添加到地图中
    //   map.panTo(point)
    //   let gc = new BMap.Geocoder();
    //   gc.getLocation(point, res => {
    //     console.log(res);
    //     this.selectLocation = res
    //   })
    // },
    detailDatas() { //详情
      let self = this
      let type = this.type || ''
      // this.request.get("/front/device/gas/" + this.deviceId).then((res) => {
      this.request.get(`/front/device/${type}/${this.deviceId}`).then((res) => {
        // console.log(11, res);
        if (res.code === 200) {
          this.datailsData = res.data
          // console.log(this.datailsData);
          // let obj =this.datailsData.region.chargePersonList[0]
          // let arry =[]
          // for(var i=0;i<4;i++){
          //   arry.push(obj)
          // }
          if (this.datailsData.region) {
            this.regionInfos = this.datailsData.region.chargePersonList
            this.regionId = this.datailsData.region.id
            this.regionName = this.datailsData.region.name
          }
          // console.log(this.regionInfos);
          let map = this.map
          let BMap = this.baiduMap
          let installGps
          if(this.datailsData.installGps){
            installGps = this.datailsData.installGps.split(',')
          } else {
            installGps = ['116.404','39.915']
          }
          // map.clearOverlays()
          this.center.lng = installGps[0] ? installGps[0] : '116.404'
          this.center.lat = installGps[1] ? installGps[1] : '39.915'
          // 根据坐标显示设备定位address
          let { lng, lat } = this.center
          AMap.plugin('AMap.Geocoder', function() {
            var geocoder = new AMap.Geocoder()
           
            geocoder.getAddress([lng, lat], function(status, result) {
              if (status === 'complete' && result.info === 'OK') {
                // result为对应的地理位置详细信息
                self.selectLocation = {
                  address: result.regeocode.formattedAddress,
                  position: { lng, lat }
                }
              }
            })
          })
          // let point = new BMap.Point(this.center.lng, this.center.lat);
          // var marker = new BMap.Marker(point); // 创建标注
          // map.addOverlay(marker); // 将标注添加到地图中
          // map.panTo(point)
          // let gc = new BMap.Geocoder();
          // gc.getLocation(point, res => {
          //   console.log(res);
          //   this.selectLocation = res
          // })
        } else if (res.code === 500) {
          this.msg.warn(res.msg)
        }
      })
    },
    makeheight(height = 260) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    editBasicinfo() {
      this.commitFlag = true
      this.styleObj = {
        'border': this.commitFlag ? '1px solid #1089FF' : 'unset'
      }
      this.$refs.myScrollbar.wrap.scrollTop = 0
    },
    submitBasicinfo() {
      let params = {
        deviceId: this.deviceId,
        deviceName: this.datailsData.name,
        installGps: this.datailsData.installGps,
        installLocation: this.datailsData.installLocation,
        regionId:this.regionId
      }
      if (!params.regionId) {
        return this.$message({ type: 'warning', message: '请选择有效的安装区域！' })
      }
      this.$confirm('此操作将修改设备信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.request.post('/front/device/edit', params).then(res => {
          if (res.code !== 200) {
            if (res.code == 500) {
              return this.$message.error(res.msg)
            }
            return
          }
          this.commitFlag = false
          this.styleObj = {
            'border': this.commitFlag ? '1px solid #1089FF' : 'unset'
          }
          this.$refs.myScrollbar.wrap.scrollTop = 0
          return this.$message.success(res.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消修改'
        });
      })
    },
    cancelBasicinfo() {
      this.commitFlag = false
      this.styleObj = {
        'border': this.commitFlag ? '1px solid #1089FF' : 'unset'
      }
      this.$refs.myScrollbar.wrap.scrollTop = 0
      this.detailDatas()
    },
    uninstallDevice() {
      this.$confirm('此操作将拆除设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.request.post(`/front/device/unInstall?id=${this.deviceId}`).then(res => {
          if (res.code !== 200) {
            if (res.code == 500) {
              return this.$message.error(res.msg)
            }
            return
          }
          this.$router.push('/deviceGas')
          this.$emit('jumpDev')
          return this.$message.success(res.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消拆'
        });
      })
    },
    // 解除
    unOutDevice () {
      this.isUnOut = true
      this.$confirm('此操作将解除设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.request.post(`/front/device/outbound/${this.deviceImei}`).then(res => {
          if (res.code !== 200) {
            if (res.code == 500) {
              return this.$message.error(res.msg)
            }
            return
          }
          this.isUnOut = false
          this.$router.push('/deviceGas')
          this.$emit('jumpDev')
          return this.$message.success(res.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消拆'
        });
      })
    },
    saveLocation() {
      // this.selectAddress = this.selectLocation
      if (JSON.stringify(this.selectLocation) == "{}") {
        this.msg.warn("请您先选择地理位置")
        return
      }
      this.mapShow = false
      this.datailsData.installGps = this.selectLocation.position.lng+','+this.selectLocation.position.lat
    },
    /*mapReady({
      BMap,
      map
    }) {
      this.baiduMap = BMap
      this.map = map
      this.mapLoading = false
      this.locationSelected = true
      // let point = new BMap.Point(this.center.lng, this.center.lat);
      // var marker = new BMap.Marker(point); // 创建标注
      // map.addOverlay(marker); // 将标注添加到地图中
      // map.panTo(point)
      // let gc = new BMap.Geocoder();
      // gc.getLocation(point, res => {
      //   console.log(res);
      //   this.selectLocation = res
      // })
      let Geo = new BMap.Geocoder();
      this.geocoder = Geo
    },
    mapReady1({
      BMap,
      map
    }) {
      let _this = this
      _this.baiduMap = BMap
      _this.map = map
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(res => {
        console.log(res);
        _this.mapLoading = false
        _this.locationSelected = true
        if (!res) {
          return
        }
        // console.log("转化前:" + res.longitude, res.latitude)
        var x_PI = 3.14159265358979324 * 3000.0 / 180.0
        var lat = +res.latitude
        var lng = +res.longitude
        var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI)
        var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI)
        var bd_lng = z * Math.cos(theta) + 0.0065
        var bd_lat = z * Math.sin(theta) + 0.006
        // console.log("转化后:" + bd_lng, bd_lat)
        _this.location.lng = bd_lng
        _this.location.lat = bd_lat
        if (!_this.flag) {
          _this.center.lng = this.location.lng
          _this.center.lat = this.location.lat
          let point = new BMap.Point(_this.center.lng, _this.center.lat);
          var marker = new BMap.Marker(point); // 创建标注
          map.addOverlay(marker); // 将标注添加到地图中
          map.panTo(point)
          let gc = new BMap.Geocoder();
          gc.getLocation(point, res => {
            console.log(res);
            _this.selectLocation = res
          })
        }
        // console.log(point);
      }, {
        enableHighAccuracy: true
      })
      let Geo = new BMap.Geocoder();
      _this.geocoder = Geo
    },*/
    mapClick(e) {
      // console.log(e);
      let map = this.map
      let BMap = this.baiduMap
      map.clearOverlays();
      var point = new BMap.Point(e.point.lng, e.point.lat);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      this.geocoder.getLocation(point, res => {
        // console.log(res);
        this.selectLocation = res
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.basicInfoContainerGas {
  .detailsDrawerBody {
    // padding: 10px 35px;

    .detailsItem {
      height: 100%;
      padding-left: 20px;

      h4 {
        font-size: 16px;
        color: #333;
        line-height: 38px;
        font-weight: bold;
        border-bottom: 1px solid #aaa;
      }

      .details {
        padding: 10px 0;
        height: 100%;

        ul {
          overflow: hidden;

          li {
            float: left;
            width: 33.33%;
            line-height: 38px;
            margin: 0 0 5px 0;

            .label {
              // display: inline-block;
              vertical-align: middle;
              color: #333;
              width: 300px;
            }

            .value {
              // display: inline-block;
              // width: calc(100% - 200px);
              width: 310px;
              height: 38px;
              padding: 0 5px 0 10px;
              box-sizing: border-box;
              vertical-align: middle;
              color: #888;
              // background: rgba(16, 137, 255, 0.05);
              background: #f4f4f5;
              border-radius: 2px;
              overflow: hidden;
              text-overflow: nowrap;
              white-space: ellipsis;

              .unit {
                margin-left: 10px;
              }
            }
          }
        }

        .submitBtns {
          overflow: hidden;

          .delSome {
            width: 82px;
            height: 36px;
            cursor: pointer;
            float: left;
            margin-right: 20px;
            font-size: 14px;
            font-family: AlibabaPuHuiTi-Medium;
            line-height: 36px;
            border: 0;
            color: #FFFFFF;
            background: #1089FF;
            border-radius: 4px;

            &:hover {
              background: #0774e0;
            }
          }

          .uninstall {
            background: #fff;
            border: 1px #1089FF solid;
            color: #1089FF;

            &:hover {
              background: rgba(16, 137, 255, 0.05);
            }
          }
          .uninstalls{
            background: #fff;
            border: 1px #ff9900 solid;
            color: #ff9900;
            &:hover{
              background: rgba(255, 153, 0, 0.05);
            }
          }
        }

        .unitType {
          font-size: 0;
          position: relative;
          .imgPosition {
            position: absolute;
            width: 38px;
            height: 38px;
            right: 0px;
            top: 0px;
            cursor: pointer;

            img {
              margin:11px 0 0 11px;
              width: 16px;
              height: 16px;
              vertical-align: top;
            }
          }
        }
      }
    }

  }
}
</style><style lang="scss">
.basicInfoContainerGas {
  font-family: AlibabaPuHuiTi-Regular;
  .vue-treeselect__control{
    border: none;
    outline: none;
    color: #888;
    // background: rgba(16, 137, 255, 0.05);
    background: #f4f4f5;
    .vue-treeselect__single-value{
      color: #888;
    }
    .vue-treeselect__input{
      height: 38px;
      color: #888;
    }
  }
  .detailsDrawerBody .detailsItem .details ul li .treeselect-box {
    overflow: visible!important;
  }
  .deviceName {
    font-size: 0;

    .el-input {
      font-size: 0;
      display: inline-block;
      width: 100%;

      .el-input__inner {
        color: #888;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
        padding: 0;
        border: unset;
        outline: unset;
        background: unset;
      }
    }
  }

  .unitType {
    font-size: 0;

    .el-input {
      font-size: 0;
      display: inline-block;
      width: 90%;

      .el-input__inner {
        color: #888;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
        padding: 0;
        border: unset;
        outline: unset;
        background: unset;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .unitMap {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 10;
    transition: all 0.1s;

    .closeBtn {
      position: absolute;
      top: 30px;
      right: 80px;
      font-size: 50px;
      color: #fff;
      cursor: pointer;
    }

    .mapBox {
      position: absolute;
      width: 80%;
      height: 80%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden;

      .input-box {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 180px;
        height: 60px;
        padding: 5px 10px;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        label {
          display: block;
          color: #666;
        }
        #tipinput {
          margin-top: 10px;
          height: 25px;
          border: 1px solid #ccc;
        }
      }      
      #map {
        width: 100%;
        height: 100%;
      }

      // .mapSearch {
      //   position: absolute;
      //   top: 10px;
      //   left: 10px;
      //   z-index: 1000;
      //   font-size: 0;

      //   .el-input {
      //     width: 300px;
      //     height: 40px;
      //     vertical-align: middle;
      //     margin-right: 10px;
      //     box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);

      //     .el-input__inner {
      //       width: 300px;
      //       height: 40px;
      //     }
      //   }

      //   .el-button {
      //     vertical-align: middle;
      //     height: 40px;
      //     line-height: 40px;
      //     padding: 0 10px;
      //     box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
      //   }
      // }

      .mapConfirm {
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        background: rgba(0, 0, 0, 0.8);
        padding: 10px 20px;
        cursor: pointer;

        span {
          float: left;
          color: #fff;
          font-size: 20px;
          width: 500px;
          line-height: 36px;
        }

        i {
          float: right;
          background: #f77a27;
          font-style: normal;
          height: 36px;
          line-height: 36px;
          border-radius: 18px;
          padding: 0 20px;
          color: #fff;
          font-size: 20px;
        }
      }
    }
  }
}
</style>
